import { Store } from 'store/index';

const isMoreResultsToFetch = (store: Store) =>
  store.search.totalAvailable > 0 &&
  store.search.totalAvailable !== store.search.offset + store.search.results.products.length;

export default isMoreResultsToFetch;
